import React from 'react';
import { Button, Form } from 'react-bootstrap';
import { Field, reduxForm } from 'redux-form';
import { TextField } from "../common/FormComponents";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faSpinner } from '@fortawesome/free-solid-svg-icons';

const validate = values => {
    const errors = {};

    if (!values.email) {
        errors.email = '* Required'
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
        errors.email = '* Invalid email address'
    }
    return errors;
};

const RequestResetForm = props => {
    const { handleSubmit } = props;

    return (
        <Form onSubmit={handleSubmit}>

            <div className="adt-flex-container">
                <div className="adt-flex-icon">
                    <FontAwesomeIcon className="text-primary" size="lg" icon={faEnvelope} fixedWidth />
                </div>
                <div className="adt-flex-item">
                    <Field component={TextField}
                        name="email"
                        type="email"
                        label="Email"
                        fullWidth
                        onChange={this.handleChange}
                        helperText={<span></span>}
                    />
                </div>
            </div>
            <Button type="submit" disabled={props.pristine || props.pending}>
                {(props.pending) ? (
                <FontAwesomeIcon className="text-primary" icon={faSpinner} spin fixedWidth />
                ) : ('')}
                Send password reset email
            </Button>
        </Form>
    )
};

export default reduxForm({ form: 'requestReset', validate, })(RequestResetForm)


// WEBPACK FOOTER //
// ./src/Auth/RequestResetForm.js